const pushToDataLayer = (eventName, ecommerceData = null, userData = null) => {
  window.dataLayer = window.dataLayer || [];
  
  // 1. Clear previous ecommerce state (Crucial for SPAs)
  window.dataLayer.push({ ecommerce: null }); 

  // 2. Push new data
  const payload = {
    event: eventName,
    ecommerce: ecommerceData,
  };

  // Only add user_data if it exists (usually only at Purchase)
  if (userData) {
    payload.user_data = userData;
  }

  window.dataLayer.push(payload);
};

export default pushToDataLayer;